export default __webpack_public_path__ + "static/header-title-dont-dark-cc7fba819edb53d15ec58b54aa1838fa2acd16b058c44cd63fed38d62910444a.png";